import type * as lazyIndex from "./lazyIndex";
import { LazyAction, LazyModule, LazyImport } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule(() => import(/* webpackChunkName: "GroupDeepLinkActions" */ "./lazyIndex"), { name: "GroupDeepLinkActions" });

export const lazyDeeplinkActionType: LazyImport<typeof lazyIndex.DeeplinkActionType, typeof lazyModule> = new LazyImport(lazyModule, m => m.DeeplinkActionType);

export const lazyInitializeDeeplink: LazyAction<typeof lazyIndex.initializeDeeplink, typeof lazyModule> = new LazyAction(lazyModule, m => m.initializeDeeplink);

export const lazyDeeplinkOnGroupDetailsLoaded: LazyAction<typeof lazyIndex.onGroupDetailsLoaded, typeof lazyModule> = new LazyAction(lazyModule, m => m.onGroupDetailsLoaded);

export const lazyDeeplinkOnGroupDetailsLoadError: LazyAction<typeof lazyIndex.onGroupDetailsLoadError, typeof lazyModule> = new LazyAction(lazyModule, m => m.onGroupDetailsLoadError);
